import { Typography } from "@mui/material";
import noResultImg from "../assets/no-result.jpg";
import { useConfig } from "../containers/ConfigContext";

export default function NoResult(props: { title?: string }) {
  const { localized } = useConfig();
  return (
    <div className="all-center-wrapper width-100p column-wrapper">
      <img width={200} src={noResultImg} alt="no result" />
      <Typography variant="body1">
        {props.title || localized("No Result")}
      </Typography>
    </div>
  );
}
